import http from './http'

const basePath = '/achievement/monograph'

const normalizeBody = (idOrPayload, payload) =>
  typeof idOrPayload === 'object' && idOrPayload !== null ? idOrPayload : { ...(payload || {}), id: idOrPayload }

const withId = (id) => `${basePath}/${id}`

export async function saveMonograph(payload) {
  const res = await http.post(`${basePath}/saveDraft`, payload)
  return res.data
}

export async function submitMonograph(payload) {
  const res = await http.post(`${basePath}/submit`, payload)
  return res.data
}

export async function createMonograph(payload) {
  return payload?.isDraft ? saveMonograph(payload) : submitMonograph(payload)
}

export async function updateMonograph(idOrPayload, payload) {
  const body = normalizeBody(idOrPayload, payload)
  if (typeof body?.isDraft === 'boolean') {
    return body.isDraft ? saveMonograph(body) : submitMonograph(body)
  }
  const res = await http.put(basePath, body)
  return res.data
}

export async function getMonograph(id) {
  const res = await http.get(withId(id))
  return res.data
}

export async function listMonographs(params) {
  const res = await http.get(basePath, { params })
  return res.data
}

export async function deleteMonograph(id) {
  const res = await http.delete(withId(id))
  return res.data
}
